document.addEventListener("DOMContentLoaded", (event) => {

    $("#drawer-cart").on("change", "#sidecartSubscriptionSelect", function (event) {
        updateSellingPlan(event.target.options[event.target.selectedIndex].dataset.variantId, event.target.options[event.target.selectedIndex].dataset.quantity, event.target.value);
    })

    $("#drawer-cart").on("click", ".sidecart-subscription-btn", function (event) {
        updateSellingPlan(event.target.dataset.variantId, event.target.dataset.quantity, event.target.dataset.sellingPlanId)
    })

    $("#drawer-cart").on("click", ".sidecart-cancel-subscription-btn", function (event) {
        updateSellingPlan(event.target.dataset.variantId, event.target.dataset.quantity, "")
    })

    // CART PAGE FUNCTION
    setTimeout(() => {
        const selects = document.querySelectorAll("#sidecartSubscriptionSelect")
        selects.forEach((select) => {
            select.addEventListener("change", function (event) {
                updateSellingPlan(event.target.options[event.target.selectedIndex].dataset.variantId, event.target.options[event.target.selectedIndex].dataset.quantity, event.target.value);
            })
        })

        const subsBtns = document.querySelectorAll(".sidecart-subscription-btn")
        subsBtns.forEach((button) => {
            button.addEventListener("click", function (event) {
                updateSellingPlan(event.target.dataset.variantId, event.target.dataset.quantity, event.target.dataset.sellingPlanId)
                
            })
        })

        const cancelSubsBtns = document.querySelectorAll(".sidecart-cancel-subscription-btn")
        cancelSubsBtns.forEach((button) => {
            button.addEventListener("click", function (event) {
                updateSellingPlan(event.target.dataset.variantId, event.target.dataset.quantity, "")
            })
        })
      }, "1000");

    

    const updateSellingPlan = function(variant_id, quantity, selling_plan_id) {
        var params = {
            type: 'POST',
            url: '/cart/change.js',
            data:  'quantity=0&id='+variant_id,
            dataType: 'json',
            success: function(cart) {
                var params = {
                    type: 'POST',
                    url: '/cart/add.js',
                    data: 'quantity=' + quantity + '&id=' + variant_id + '&selling_plan=' + selling_plan_id,
                    dataType: 'json',
                    success: function(line_item) {
                        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
                        if(location.href == 'https://replenix.com/cart') {location.reload();}
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        console.log(XMLHttpRequest, textStatus);
                    }
                };
                $.ajax(params);
            },
            error: function(XMLHttpRequest, textStatus) {
               console.log(XMLHttpRequest, textStatus);
            }
        };
        $.ajax(params);
    }
});